
// assets

import html from "../assets/img/technologies/html.png";
import css from "../assets/img/technologies/css.png";
import js from "../assets/img/technologies/js.png";
import tailwind from "../assets/img/technologies/tailwind.png";
import bootstrap from "../assets/img/technologies/bootstrap.png";
import react from "../assets/img/technologies/react.png";
import redux from "../assets/img/technologies/redux.png";
import typescript from "../assets/img/technologies/typescript.png";
import apexchart from "../assets/img/technologies/apexchart.png";
import materialui from "../assets/img/technologies/materialui.png";

import figma from "../assets/img/technologies/figma.png";
import chartjs from "../assets/img/technologies/chartjs.png";

import nodejs from "../assets/img/technologies/nodejs.png";
import mongodb from "../assets/img/technologies/mongodb.png";
import sass from "../assets/img/technologies/sass.png";
import git from "../assets/img/technologies/git.png";

import express from "../assets/img/technologies/express.png";
import firebase from "../assets/img/technologies/firebase.png";
import jest from "../assets/img/technologies/jest.png";
import notion from "../assets/img/technologies/notion.png";
import trello from "../assets/img/technologies/trello.png";
import jira from "../assets/img/technologies/jira.png";
import manychat from "../assets/img/technologies/manychat.png";
import typeform from "../assets/img/technologies/typeform.png";
// import pwa from "../assets/img/technologies/pwa.png";
import workbox from "../assets/img/technologies/workbox.png";
import storybook from "../assets/img/technologies/storybook.png";

import swagger from "../assets/img/technologies/swagger.png";


    


export const projects = [
    {
      title: "HTML5",
      image: html,
      color: "#FF7816",
    },
    {
      title: "CSS3",
      image: css,
      color: "#35A8DB",
    },
    {
      title: "JavaScript",
      image: js,
      color: "#FFDF00",
    },
    {
      title: "React Js",
      image: react,
      color: "#FFDF00",
    },
    {
      title: "Redux",
      image: redux,
      color: "#FFDF00",
    },
    {
      title: "TypeScript",
      image: typescript,
      color: "#FFDF00",
    },
    {
      title: "Tailwind",
      image: tailwind,
      color: "#FFDF00",
    },
    {
      title: "Bootstrap",
      image: bootstrap,
      color: "#FFDF00",
    },
    {
      title: "Material UI",
      image: materialui,
      color: "#FFDF00",
    },
    {
      title: "Apexchart",
      image: apexchart,
      color: "#FFDF00",
    },
    {
      title: "ChartJs",
      image: chartjs,
      color: "#FFDF00",
    },
    {
      title: "Figma",
      image: figma,
      color: "#FFDF00",
    },
    {
      title: "Nodejs",
      image: nodejs,
      color: "#FFDF00",
    },
    {
      title: "MongoDB",
      image: mongodb,
      color: "#FFDF00",
    },
    {
      title: "Sass",
      image: sass,
      color: "#FFDF00",
    },
    {
      title: "Git",
      image: git,
      color: "#FFDF00",
    },
    {
      title: "Express",
      image: express,
      color: "#FFDF00",
    },
    {
      title: "Firebase",
      image: firebase,
      color: "#FFDF00",
    },
    {
      title: "Swagger",
      image: swagger,
      color: "#FFDF00",
    },
    {
      title: "Jest",
      image: jest,
      color: "#FFDF00",
    },
    {
      title: "Notion",
      image: notion,
      color: "#FFDF00",
    },
    {
      title: "Trello",
      image: trello,
      color: "#FFDF00",
    },
    {
      title: "Jira",
      image: jira,
      color: "#FFDF00",
    },
    {
      title: "Workbox",
      image: workbox,
      color: "#FFDF00",
    },
    // {
    //   title: "PWA",
    //   image: pwa,
    //   color: "#FFDF00",
    // },
    {
      title: "Storybook",
      image: storybook,
      color: "#FFDF00",
    },
    {
      title: "Typeform",
      image: typeform,
      color: "#FFDF00",
    },
    {
      title: "Manychat",
      image: manychat,
      color: "#FFDF00",
    },
    
  ];